<template>
  <div>
    <h4 class="mb-4"><strong>El número no es Virgin Mobile</strong></h4>
    <p></p>

    <a :href="redirectUrl" class="btn btn-primary" type="button">
      Ir a Portabilidad
    </a>

  </div>
</template>

<script>
export default {
  name: 'PaymentNotTariff',
  props: {
    redirectUrl: {
      type: String,
      default: 'https://mecambioa.virginmobile.cl/'
    }
  },

  setup() {
    return {
      error: {
        msisdn: false
      },
      msisdn: '',
    }
  },
}
</script>

<style scoped>
</style>
